import { Images } from 'assets/images';
import {
  ModalContent,
  ModalWrapper,
  CloseModalIcon,
  ConfirmPasswordText,
  ForYourSecurityText,
  InputWithButtons,
  PasswordInput,
  CancelAndSaveButtons,
  CancelButton,
  SaveButton,
} from 'admin/components/ProfileModals/styled';

export const ProfileDeleteModal = ({ handleConfirmModal }) => (
  <ModalWrapper isDeleteModal>
    <CloseModalIcon src={Images.closeBlueIcon} onClick={handleConfirmModal} />
    <ModalContent>
      <ConfirmPasswordText>Delete Account</ConfirmPasswordText>
      <ForYourSecurityText>
        Are you sure you want to delete your account? Once your account is deleted,
        all of its resources and data will be permanently deleted. Please enter your
        password to confirm you would like to permanently delete your account.
      </ForYourSecurityText>

      <InputWithButtons>
        <PasswordInput placeholder="Password" />
        <CancelAndSaveButtons>
          <CancelButton onClick={handleConfirmModal}>Cancel</CancelButton>
          <SaveButton onClick={handleConfirmModal}>Save</SaveButton>
        </CancelAndSaveButtons>
      </InputWithButtons>
    </ModalContent>
  </ModalWrapper>
);
